export class DriversLicenseTypeItem {
  public licenseTypeCd: number = null;
  public licenseIssueDate: string = null;

  constructor() {
  }
}
